import ModalTableTexbinReplacement from "./modal-table-textbin-replacement";

export default ModalTableTexbinReplacement;